class RecordListSearchCtrl {
  constructor($scope) {
    'ngInject';

    this.formName = `recordListSearch${$scope.$id}`;
    this.termName = `recordListSearchTerm${$scope.$id}`;
  }

  clearSearch(){
    
    this.term = '';

  }
  
}

export default {
  bindings: {
    'term': '='
  },
  templateUrl: 'record-utilities/record-list-search/record-list-search.component.html',
  controller: RecordListSearchCtrl
}
